import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  newPassword:string;
  confirmPassword:string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService:HelperService) { }

  ngOnInit() {
  }
  Update(){  

    if(this.newPassword==undefined){
      alert("Please Enter New Password");
      return;
    }
    else if(this.confirmPassword==undefined){
      alert("Please Enter Confirm Password");
      return; 
    }
    else if(this.newPassword!=this.confirmPassword){
      alert("New Password and confirm Password must be same");
      return;
    }


    
    const changePassword =    
    
    {
      "userEmail":this.helperService.getEmail(),"token":this.helperService.studented_atob(this.helperService.getToken()),"newPassword":this.newPassword,"confirmPassword":this.confirmPassword
    }

    this.apiService.changePassword(changePassword).subscribe((res: any) =>  {     
      alert("Password Updated Successfully");
      this.router.navigateByUrl(`login`);

    })
  }

}
